let vet1,
  vet2,
  vet3,
  vet4,
  vet5,
  vet6,
  vet7,
  vet8,
  vet9,
  vet10,
  vet11,
  vet12,
  vet13,
//   vet14,
  vet15,
  vet16,
  vet17,
  vet18,
  vet19,
  vet20,
  vet21,
  vet22;
let tvet1,
  tvet2,
  tvet3,
  tvet4,
  tvet5,
  tvet6,
  tvet7,
  tvet8,
  tvet9,
  tvet10,
  tvet11,
  tvet12,
  tvet13,
//   tvet14,
  tvet15,
  tvet16,
  tvet17,
  tvet18,
  tvet19,
  tvet20,
  tvet21,
  tvet22;

try {
  vet1 = require("../images/vet2/황야원.png");
} catch (e) {
  vet1 = require("../images/vet2/no-img.png");
}
try {
  vet2 = require("../images/vet2/백주예.png");
} catch (e) {
  vet2 = require("../images/vet2/no-img.png");
}
try {
  vet3 = require("../images/vet2/이희수.png");
} catch (e) {
  vet3 = require("../images/vet2/no-img.png");
}
try {
  vet4 = require("../images/vet2/이지은.png");
} catch (e) {
  vet4 = require("../images/vet2/no-img.png");
}
try {
  vet5 = require("../images/vet2/김동욱.png");
} catch (e) {
  vet5 = require("../images/vet2/no-img.png");
}
// try {
//   vet6 = require("../images/vet2/천병규.png");
// } catch (e) {
//   vet6 = require("../images/vet2/no-img.png");
// }
try {
  vet7 = require("../images/vet2/이아림.png");
} catch (e) {
  vet7 = require("../images/vet2/no-img.png");
}
try {
  vet8 = require("../images/vet2/임가영.png");
} catch (e) {
  vet8 = require("../images/vet2/no-img.png");
}
// try {
//   vet9 = require("../images/vet2/정기욱.png");
// } catch (e) {
//   vet9 = require("../images/vet2/no-img.png");
// }
// try {
//   vet10 = require("../images/vet2/유현철.png");
// } catch (e) {
//   vet10 = require("../images/vet2/no-img.png");
// }
try {
  vet11 = require("../images/vet2/노정은.png");
} catch (e) {
  vet11 = require("../images/vet2/no-img.png");
}
try {
  vet12 = require("../images/vet2/최민정.png");
} catch (e) {
  vet12 = require("../images/vet2/no-img.png");
}
// try {
//   vet13 = require("../images/vet2/최정민.png");
// } catch (e) {
//   vet13 = require("../images/vet2/no-img.png");
// }
// try {
//   vet14 = require("../images/vet2/김나연.png");
// } catch (e) {
//   vet14 = require("../images/vet2/no-img.png");
// }
try {
  vet15 = require("../images/vet2/나평안.png");
} catch (e) {
  vet15 = require("../images/vet2/no-img.png");
}
// try {
//   vet16 = require("../images/vet2/sbk2.png");
// } catch (e) {
//   vet16 = require("../images/vet2/no-img.png");
// }
// try {
//   vet17 = require("../images/vet2/이호연.png");
// } catch (e) {
//   vet17 = require("../images/vet2/no-img.png");
// }
try {
  vet18 = require("../images/vet2/원주연.png");
} catch (e) {
  vet18 = require("../images/vet2/no-img.png");
}
try {
  vet19 = require("../images/vet2/최혜은.png");
} catch (e) {
  vet19 = require("../images/vet2/no-img.png");
}
try {
  vet20 = require("../images/vet2/김동준.png");
} catch (e) {
  vet20 = require("../images/vet2/no-img.png");
}
try {
  vet21 = require("../images/vet2/고민정.png");
} catch (e) {
  vet21 = require("../images/vet2/no-img.png");
}
try {
  vet22 = require("../images/vet2/황동혁.png");
} catch (e) {
  vet22 = require("../images/vet2/no-img.png");
}

try {
  tvet1 = require("../images/vet/황야원.png");
} catch (e) {
  tvet1 = null;
}
try {
  tvet2 = require("../images/vet/백주예.png");
} catch (e) {
  tvet2 = null;
}
try {
  tvet3 = require("../images/vet/이희수.png");
} catch (e) {
  tvet3 = null;
}
try {
  tvet4 = require("../images/vet/이지은.png");
} catch (e) {
  tvet4 = null;
}
try {
  tvet5 = require("../images/vet/김동욱.png");
} catch (e) {
  tvet5 = null;
}
// try {
//   tvet6 = require("../images/vet/천병규.png");
// } catch (e) {
//   tvet6 = null;
// }
try {
  tvet7 = require("../images/vet/이아림.png");
} catch (e) {
  tvet7 = null;
}
try {
  tvet8 = require("../images/vet/임가영.png");
} catch (e) {
  tvet8 = null;
}
// try {
//   tvet9 = require("../images/vet/정기욱.png");
// } catch (e) {
//   tvet9 = null;
// }
// try {
//   tvet10 = require("../images/vet/유현철.png");
// } catch (e) {
//   tvet10 = null;
// }
try {
  tvet11 = require("../images/vet/노정은.png");
} catch (e) {
  tvet11 = null;
}
try {
  tvet12 = require("../images/vet/최민정.png");
} catch (e) {
  tvet12 = null;
}
// try {
//   tvet13 = require("../images/vet/최정민.png");
// } catch (e) {
//   tvet13 = null;
// }
// try {
//   tvet14 = require("../images/vet/김나연.png");
// } catch (e) {
//   tvet14 = null;
// }
try {
  tvet15 = require("../images/vet/나평안.png");
} catch (e) {
  tvet15 = null;
}
// try {
//   tvet16 = require("../images/vet/sbk1.png");
// } catch (e) {
//   tvet16 = null;
// }
// try {
//   tvet17 = require("../images/vet/이호연.png");
// } catch (e) {
//   tvet17 = null;
// }
try {
  tvet18 = require("../images/vet/원주연.png");
} catch (e) {
  tvet18 = null;
}
try {
  tvet19 = require("../images/vet/최혜은.png");
} catch (e) {
  tvet19 = null;
}
try {
    tvet20 = require("../images/vet/김동준.png");
} catch (e) {
    tvet20 = null;
}
try {
    tvet21 = require("../images/vet/고민정.png");
} catch (e) {
    tvet21 = null;
}
try {
    tvet22 = require("../images/vet/황동혁.png");
} catch (e) {
    tvet22 = null;
}



const vetInfo = [
  {
    id: 1,
    position: "대표원장/외과원장",
    name: "황야원",
    title: "충북대학교수의외과학 박사 졸업",
    img: vet1,
    timg: tvet1,
    greetings:
      "치료는 아픈 아이들의 마음을 이해하는 것부터 시작입니다. 보호자님들과 아이들이 함께하는 시간의 시작과 끝을 책임지겠습니다.",
    history: [
      "충북대학교 수의과대학 학사 졸업",
      "충북대학교 수의과대학 수의외과학 석사 졸업",
      "충북대학교 수의과대학 수의외과학 박사 졸업",
      "충북대학교 동물의료센터 외과 전임수의사",
      "충북대학교 동물의료센터 조교",
      "전) 인천SKY동물의료센터 외과원장",
      "현) 한국수의외과학회 정회원, 학술편집위원",
      "현) 한국동물병원협회 이사",
      "현) 충북대학교 수의과대학 겸임교수",
      "현) 부평SKY동물의료센터 대표원장/외과원장",
    ],
    paper: [
      "Hwang Y, Park J, Choi SH, Kim G. Traumatic and non-traumatic osteonecrosis in the femoral head of a rabbit model. Laboratory animal research. 2011 Jun 1;27(2):127-31.",
      "Evaluation of stability and biocompatibility on poly (2-hydroxyethyl methacrylate)-poly(methyl methacrylate)-based artificial cornea in rabbits (석사학위 논문)",
      "Hwang Y, Kim G. Evaluation of stability and biocompatibility of PHEMA-PMMA keratoprosthesis by penetrating keratoplasty in rabbits. Laboratory animal research. 2016 Oct;32(4):181-6.",
      "Hwang Y, Oh H, Chang D, Kim G. Persistent left cranial vena cava with congenital heart defect in two dogs. Korean Journal of Veterinary Research. 2016 Sep 1;56(3):193-5.",
      "Hwang Y, Kim D, Kim G. Gait analysis in clinically healthy small to toy breed dogs using a pressure plate. Journal of Biomedical and Translational Research (JBTR). 2017 Sep 30;18(3):93-6.",
      "Hwang Y, Kim D, Chang D, Ahn B, Kim YB, Kim G. Effects of neural stem cells and 5-fluorocytosine in canine metastatic lung tumor. Journal of veterinary science. 2017 Jun 1;18(2):257-60.",
      "Hwang Y, Yoo S, Kim G. Surgical treatment of spontaneous pneumothorax associated with lobal emphysema in a dog. The Thai Journal of Veterinary Medicine. 2017;47(2):265-71.",
      "Hwang Y, Kang J, Chang D, Kim G. Surgical Removal of the Lung Lobe Metal Foreign Body in a Dog. 한국임상수의학회지. 2017 Apr;34(2):108-11.",
      "Hwang Y, Hyun SH, Hwang WS, Kim G. Normal bone healing in three cloned dogs with long bone fractures. Turkish Journal of Veterinary and Animal Sciences. 2017 Feb 21;41(1):142-6.",
      "Effectiveness of a Canine Gait Pressure Plate for the Clinical Analysis of Hindlimb Lameness in Small Breed Dogs (박사학위 논문)",
      "APVC in Thailand 2012, 포스터발표 : Treatment of diaphragmatic hernia by using transverse colon to repair the hernia defect in a dog",
      "WVC in Praha Czech 2013, 포스터발표 : The influence of low level laser therpy on bone healing in rat model",
      "2014 한국임상수의학회 구두발표 : Acquired Hiatal Hernia after Surgical Repair of Diaphragmatic Hernia in a Cat",
      "APVC in Thailand 2014, 포스터발표 : Permanent tracheostomy and chemotherapy for thyroid carcinoma",
      "2015 한국임상수의학회 구두발표 : Force Plate Analysis of the Walking Gait in Lameness Dogs",
      "2016 한국임상수의학회 포스터발표 : Torsion of a left lateral lobe of the liver in a cat with hypoalbuminemia",
      "AMAMS in Korea 2017, 구두발표 : Radius and Ulna Fractures in Toy Breed Dogs.",
      "ESVOT courses in Cremona Italy 2019, TPLO advanced, Patella Groove Replacement 이수",
      "2023 인천수의컨퍼런스 강의 : 호흡곤란을 유발하는 상부 호흡기 질환의 수술",
    ],
    education: [],
    completion: [],
  },
  {
    id: 2,
    position: "내과원장",
    name: "백주예",
    title: "충북대학교 수의내과학 석사 졸업",
    img: vet2,
    timg: tvet2,
    greetings: "모든 동물들이 건강하고 행복하도록 최선을 다하겠습니다.",
    history: [
      "충북대학교 수의과대학 학사 졸업",
      "충북대학교 수의과대학 수의내과학 석사 졸업",
      "충북대학교 동물의료센터 내과 전임수의사",
      "전) 웨스턴 동물의료센터 내과과장",
      "현) 부평SKY동물의료센터 내과원장",
    ],
    paper: [
      "Serum adiopokine concentrations in dogs with acute pancreatitis. J Vet Intern Med. 2014 Nov;28(6):1760-9",
      "Cardiogenic pulmonary edema in a dog following initiation of therapy for concurrent hypoadrenocorticism and hypothyroidism. J Am Anim Hosp Assoc. 2016 Nov.Dec;52(6):378-384",
    ],
    education: [],
    completion: [],
  },
  {
    id: 3,
    position: "내과과장",
    name: "이희수",
    title: "전남대학교 수의내과학 석사 과정",
    img: vet3,
    timg: tvet3,
    greetings: "반려동물과 함께하는 가족의 행복을 위해 늘 함께 하겠습니다.",
    history: [
      "충북대학교 수의과대학 학사 졸업",
      "전남대학교 수의과대학 수의내과학 석사 과정",
      "부평SKY동물의료센터 진료수의사",
      "현) 부평SKY동물의료센터 내과과장",
    ],
    paper: [],
    education: [],
    completion: [],
  },
  {
    id: 4,
    position: "외과과장",
    name: "이지은",
    title: "충북대학교 수의외과학 석사 졸업",
    img: vet4,
    timg: tvet4,
    greetings:
      "근거 중심의 정확한 지식을 바탕으로 진정성 있는 수의사가 되도록 최선을 다하겠습니다.",
    history: [
      "충북대학교 수의과대학 학사 졸업",
      "충북대학교 동물병원 외과 수련의",
      "충북대학교 수의과대학 수의외과학 석사 졸업",
      "전) 24시대전동물의료센터 외과과장",
      "현) 부평SKY동물의료센터 외과과장",
    ],
    paper: [
      "Biomechanical Evaluation of Dorsal Wire Fixation for ToyBreed Dogs with Atlantoaxial Instability in a Rabbit Model (석사학위 논문)",
      "2019 AMAMS 포스터 발표 : Torsion of a left lateral lobe of the liver in a cat with hypoalbuminemia",
      "2021 추계임상수의학회 구두 발표 : Anatomical and Biomechanical Analysis of Rabbit Atlas Bone for Atlantoaxial Dorsal Fixation : A Cadaveric Study",
    ],
    education: [],
    completion: [],
  },
  {
    id: 21,
    position: "외과과장",
    name: "고민정",
    title: "건국대학교 수의과대학 박사 졸업",
    img: vet21,
    timg: tvet21,
    greetings:
      "작은 이상 신호도 가볍게 넘기지 않는 진료를 약속드립니다.",
    history: [
      "건국대학교 수의과대학 학사 졸업",
      "건국대학교 수의과대학 박사 졸업 (석박통합과정)",
      "건국대학교 수의과대학 외과 조교",
      "건국대학교 부속동물병원 외과 진료수의사",
      "건국대학교 부속동물병원 일반외과 및 신경/정형외과 chief",
      "현) 부평SKY동물의료센터 외과과장",
    ],
    paper: [
      "Ko MJ, Song KM, Yoon HY. Clinical evaluation and surgical intervention for diaphragmatic eventration mimicking peritoneopericardial hernia in a cat. J Vet Sci. 2024 Mar;25(2):e19.",
      "Ko MJ., Koh JW, Kim JH, and Yoon HY. Prophylactic surgical removal of asymptomatic large pedunculated hepatic focal nodular hyperplasia in a dog. Slov Vet Res. 2025 Mar;Early View.",
      "Ko MJ, Kim MY. Force-activated separation devices: a preventive strategy for intravenous line disconnection in canine patients. Front Vet Sci. 2025 Mar;12:1547277.",
      "Ko MJ., Yoon HY. Combination of irreversible and calcium electroporation to overcome heterogeneity-associated incomplete ablation in the pancreas. Sci Rep. 2026 Apr;16(1):17735.",
      "2023 한국임상수의학회 구두발표: Clinical Evaluation and Surgical Intervention for Diaphragmatic Eventration Mimicking Peritoneopericardial Hernia in a British Short Hair Cat",
      "2024 한국임상수의학회 구두발표: Surgical Removal and Re-assessment of Intranasal Mass Suspected as Rhinitis in a Dog",
      "2025 한국임상수의학회 구두발표: Effectiveness of Chemically Assisted Dissection as a Treatment for Cholesteatoma in a Dog",
    ],
    education: [],
    completion: [],
  },
//   {
//     id: 16,
//     position: "외과과장",
//     name: "송보경",
//     title: "충북대학교 수의과대학 석사",
//     img: vet16,
//     timg: tvet16,
//     greetings: "아이들을 제 가족처럼 소중히 여기며 감동과 희망을 전하는 수의사가 되겠습니다.",
//     history: [
//         "충북대학교 수의과대학 졸업",
//         "충북대학교 수의과대학 수의외과학 석사 졸업",
//         "충북대학교 동물의료센터 정형/신경외과 전임수의사",
//         "충북대학교 동물의료센터 조교 (세종분원)",
//         "전) 부평SKY동물의료센터 진료수의사",
//         "현) 부평SKY동물의료센터 외과과장",
//     ],
//     paper: [
//         "2023 추계임상수의학회 포스터 발표 : Correction of Angular Limb Deformity with Three Dimensional Printing Bone Cutting Guide in a Dog ",
//         "2023 AiSVS 포스터 발표 : MRI-Based Prediction of Recurrent Sites in Canine Thoracolumbar Intervertebral Disc Disease ",
//         "2024 FECAVA 포스터 발표 : Prediction Recurrence in Canine TL-IVDD: MRI Findings and Prophlyactic Decompression Strategies ",
//         "MRI Assessment of Recurrent Thoracolumbar Intervertebral Disc Disease in Dogs (석사학위 논문) ",
//         "ESVOT dry-lab courses in Lisbon 2024, Carpal Arthrodesis with Novel Titanium Plates 이수 ",
//     ],
//     education: [],
//     completion: [],
//   },
//   {
//     id: 5,
//     position: "외과과장",
//     name: "김동욱",
//     title: "충북대학교 수의외과학 박사 졸업",
//     img: vet5,
//     timg: tvet5,
//     greetings:
//       "아이들을 제 가족처럼 소중히 여기며 감동과 희망을 전하는 수의사가 되겠습니다.",
//     history: [
//       "충북대학교 수의과대학 학사 졸업",
//       "충북대학교 동물병원 수련의",
//       "충북대학교 수의과대학 수의외과학 박사 졸업",
//       "현) 한국수의외과학회 정회원, 학술편집위원",
//       "현) Certified PennHIP Member",
//       "현) 부평SKY동물의료센터 외과과장",
//     ],
//     paper: [
//       "Hwang Y, Kim D, Chang D, Ahn B, Kim Y-B, Kim G. Effects of neural stem cells and 5-fluorocytosine in canine metastatic lung tumor. J Vet Sci. 2017 18(2): 257-260.",
//       "Hwang Y, Kim D, Kim G. Gait analysis in clinically healthy small to toy breed dogs using a pressure plate. J Biomed Transl Res. 2017 18(3): 93-96.",
//       "Kashif M, Kim D, Kim G. In vitro antiproliferative and apoptosis inducing effect of a methanolic extract of Azadirachta indica oil on selected cancerous and noncancerous cell lines. Asian Pac J Trop Med. 2018 11(10): 555-561.",
//       "Yoon H, Yu J, An T, Lee H, Kim H, Kim D, Chang J, Kang J-H, Kim G, Chang D. Magnetic resonance findings of a canine benign uveal melanocytoma. J Vet Clin. 2018 35(5): 233-236.",
//       "Kim D, Na K-J, Kim G. Prognosis and outcomes of forelimb amputation in two raccoon dogs. J Biomed Transl Res. 2020 21(2): 91-94.",
//       "Kim D, Kim G. Correction of diaphragmatic hernia using the transverse colon in a dog. Thai J Vet Med. 2020 50(3): 445-449.",
//       "Kim D, Oh H, Na K-J, Chang D, Kim G. Long-term follow-up of a cat with a undetermined osteoporotic bone disease managed with multiple intramedullary pins. J Feline Med Surg Open Rep. 2020 6(2): 1-4.",
//       "Kim D, Hwang Y, Yoo S, Oh H, Kim G. Evaluation of diseases affecting hindlimb lameness in domestic small breed dogs. J Vet Clin. 2020 37(6): 297-300.",
//       "Kim D, Na K-J, Chang D, Kim G. Left lateral liver lobe torsion in a Siamese cat. Thai J Vet Med. 2021 51(2): 369-373.",
//       "Sung M, Kim D, Choi W, Bae B, Lee S, Hwang Y, Na K-J, Kim G. Comparison of post-operative C- reactive protein levels between elective general and orthopedic surgery in dogs. J Biomed Transl Res. 2021 22(3): 105-110.",
//       "Jeong S, Kim D, Kim W-J, Kim G. Detection of volatile organic compounds from human prostate cancer cell using canine olfaction. J Vet Behav. 2021 49: 80-84.",
//       "Kim D, Chang D, Kim G. Congenital portosystemic shunt concurrent with an atrial septal defect in a Maltese dog. Open Vet J. 2021 11(4): 724-727.",
//       "Bae B, Kim D, Oh H, Kim G. Biomechanical analysis of atlantoaxial dorsal fixation using finite element models. Thai J Vet Med. 2022 52(1): 185-192.",
//       "Lee J, Kim D, Oh H, Lee S, Choi SH, Kim G. Radiographic comparison of cranial tibial wedge osteotomy versus tibial plateau leveling osteotomy: A cadaveric study. J Vet Clin. 2022 39(3): 93-99.",
//       "Park G, Kim D, Jeong S, Park D, Kim G. Odor detection of cancer cell metabolites by scent- detection dogs. Thai J Vet Med. 2022 52(3): 537-541.",
//       "Kim D, Chang D, Kim G. Radiographic evaluation of atlas and axis anomalies in toy breed dogs with and without atlantoaxial subluxation. In Vivo. 2022 36(6): 2751-2755.",
//       "Kim D, Lee S, Kim G. Application of a modified dorsal wiring method in toy breed dogs with atlantoaxial subluxation. In Vivo. 2023 37(1): 247-251.",
//       "Kim D, Oh H, Ahn H, An B, Park D, Na K-J, Kim G. Comparison of serum bile acid concentrations between Maltese and other breeds of dogs with portosystemic shunt. In Vivo. 2023 37(2): 709-713.",
//       "Park S, Park G, Rieu M-S, Kim T, Kim D, Lee S, Kim G. Evaluating disease patterns of military working dogs in the Republic of Korea: A retrospective study. Animals. 2023 13(8): 1400.",
//     ],
//     education: [],
//     completion: [],
//   },
//   {
//     id: 6,
//     position: "영상의학과장",
//     name: "천병규",
//     title: "전남대학교 영상의학과 석사 졸업",
//     img: vet6,
//     timg: tvet6,
//     greetings: "다정한 손길로, 숨은 질환도 꼼꼼하게 찾아내도록 하겠습니다.",
//     history: [
//       "전남대학교 수의과대학 학사 졸업",
//       "전남대학교 수의과대학 영상의학과 석사 졸업",
//       "전) 인천SKY동물의료센터 영상의학과장",
//       "현) 부평SKY동물의료센터 영상의학과장",
//     ],
//     paper: [
//       'American Journal of Veterinary Research 논문개제(2016): "Comparison of contrast media for visualization of the colon of healthy dogs during computed tomography and ultrasonography"',
//       'Journa of Veterinary Science 논문 개제(2018): "Variation of canine vertebral bone architecture in computed tomography"',
//       '2014 전남대학교 수의과대학 증례보고회 발표" 복강 유래 종괴에 대한 CT 검사 적용 증례"',
//       "2014~2015 한국 수의영상의학연구회 학술대회 참가",
//       '2014 미국 세인트루이스 ACVR scientific conference 참가 및 포스터 발표 "Variation of canine vertebral bone architecture in computed tomography"',
//       "2014 추계 한국임상수의학회 연제 발표",
//       '2014 대한수의사회지 투고 "흉부, 복부에서 발생한 종양성 병변의 영상 검사와 전이 평가"',
//       '2015 추계 한국임상수의학회 포스터 발표 "Contrast protocol for evaluation of colon with CT and ultrasonography "',
//     ],
//     education: [],
//     completion: [],
//   },
  {
    id: 7,
    position: "영상의학과장",
    name: "이아림",
    title: "충남대학교 영상의학과 석사 졸업",
    img: vet7,
    timg: tvet7,
    greetings: "언제나 믿고 의지할 수 있는 평생 주치의가 되겠습니다.",
    history: [
      "충남대학교 수의과대학 학사 졸업",
      "충남대학교 부속동물병원 영상의학과 진료수의사",
      "충남대학교 수의과대학 영상의학과 석사 졸업",
      "충남대학교 수의과대학 본과 실습 조교",
      "로얄캐닌 코리아 대학생 엠버서더 8기",
      "한국임상수의학회 상임이사 간사 (2022)",
      "NIA 반려동물 질병진단 AI 개발 사업 참여 연구원",
      "SK telecom AI 기반 수의영상진단 솔루션 개발 사업 참여 연구원",
      "2024 고양이수의사회 심장초음파 실습 강사",
      "2024 코벳 SAMUSUNG SONO VET Academy 대전 강사",
      "2024 GE 초음파 아카데미 강사",
      "현) 부평SKY동물의료센터 영상의학과장",
    ],
    paper: [
      "Lee A, Lee S, Choi H, Lee Y.  Computed Tomographic and Magnetic Resonance Imaging Features of Oral Melanoma in a Dog.  J Vet Clin 2023;40:370-374.",
      "Evaluation of Renal Cortical Microvasculature Using Superb Microvascular Imaging in Dogs.",
      "2021 임상수의학회 추계학술대회 발표 - Computed tomographic and Magnetic Resonance Imaging Findings of Oral Melanoma in a Dog.",
      "2021 Canon Vet Academy 참가",
      "2022 ICMRI 참가",
      "2023 임상수의학회 춘계학술대회 발표 - Evaluation of Renal Cortical Microvasculature Using Superb Microvascular Imaging – Comparison of Normal to Chronic Kidney Diseas",
    ],
    education: [],
    completion: [],
  },
  {
    id: 20,
    position: "영상의학과장",
    name: "김동준",
    title: "충남대학교 수의과대학 졸업",
    img: vet20,
    timg: tvet20,
    greetings: "눈에 보이지 않는 통증의 원인, 정밀하게 짚어내겠습니다.",
    history: [
      "충남대학교 수의과대학 졸업",
      "충남대학교 부속동물병원 영상의학과 진료수의사",
      "충남대학교 수의과대학 영상의학과 석사 수료",
      "충남대학교 수의과대학 본과 실습 조교",
      "SK telecom AI 기반 수의영상진단 솔루션 개발 사업 참여 연구원",
      "2024 SAMSUNG SONO VET Academy 충청 강사",
      "전) 고려동물메디컬센터 영상의학과장",
      "현) 부평SKY동물의료센터 영상의학과장",
    ],
    paper: [
      "Kim D, Choi H, Lee Y. Magnetic Resonance Imaging and Management of Suspected Bilateral C2 Hypertrophic Ganglioneuritis in a Yorkshire Terrier Dog: A Case Report. Korean J Vet Res 2025;65(1):e6.",
      "2022 임상수의학회 춘계학술대회 포스터 발표 - Computed Tomographic Features of Gallbladder Agenesis in a Golden Retriever",
      "2023 임상수의학회 춘계학술대회 발표 Magnetic resonance imaging and management of suspected bilateral C2 hypertrophic ganglioneuritis in a Yorkshire Terrier dog: a case report",
      "2025 FASAVA 포스터 발표 - CT Lymphangiography Reveals a Subcutaneous Collateral Lymphatic Pathway Secondary to Thoracic Duct Obstruction in a Dog with Intestinal Lymphangiectasia",
      "2022, 2023 Canon Vet Academy 참가",
      "2022, 2024 ICMRI 참가",
      "2023 Southern European Veterinary Conference, SEVC 참가",
    ],
    education: [],
    completion: [],
  },
  {
    id: 8,
    position: "안과/치과과장",
    name: "임가영",
    title: "충북대학교 수의안과/치과 석사 졸업",
    img: vet8,
    timg: tvet8,
    greetings:
      "모든 환자들은 특별하고 소중합니다. 아이들의 건강을 위해 헌신하겠습니다.",
    history: [
      "충북대학교 수의과대학 수의학사 졸업 ",
      "충북대학교 수의과대학 수의임상학 석사 졸업 (안과, 치과 전공)",
      "충북대학교 동물의료센터 수련 수의사 (안과, 치과, 두경부외과)",
      "충북대학교 수의과대학 수의안과학 실습 조교",
      "충북대학교 수의과대학 수의임상학 실험실 연구원",
      "한국수의안과연구회 정회원",
      "현) 부평SKY동물의료센터 안과/치과과장",
    ],
    paper: [
      "제 10차 한국수의안과연구회 정기총회&세미나",
      "한국오가노이드 학회 동계 교육심포지움",
      "한국임상수의학회 춘계학술대회 컨퍼런스, 2019",
      "차의과학대학교 오가노이드연구센터 제2회 오가노이드 심포지움",
      "Tissue Engineering & Regernerative Medicine international Society(TERMIS) AP 2019",
      "한국임상수의학회 추계학술대회 포스터 발표, Immunomodulatory intervention in chronic masticatory muscle myositis, 2019",
      "대한수의학회 추계학술대회 포스터 발표 및 컨퍼런스 이수, The production of decellularized scleral xeno-graft using porcine eyes, 2020",
    ],
    education: [],
    completion: [],
  },
//   {
//     id: 14,
//     position: "응급의학과장",
//     name: "김나연", // 개명
//     title: "제주대학교 수의학사 졸업",
//     img: vet14,
//     timg: tvet14,
//     greetings: "따뜻한 마음과 전문성으로 함께하겠습니다.",
//     history: [
//       "제주대학교 수의과대학 수의학사 졸업",
//       "Manifee valley animal clinic in CA 연수",
//       "전) 대구동물메디컬센터 응급의학과장",
//       "전) 아프리카동물병원 부원장",
//       "전) 가나동물병원 응급의학 원장 ",
//       "현) 부평SKY동물의료센터 응급의학과장",
//     ],
//     paper: [],
//     education: [],
//     completion: [],
//   },
  {
    id: 15,
    position: "응급의학과장",
    name: "나평안",
    title: "전북대학교 수의학사 졸업",
    img: vet15,
    timg: tvet15,
    greetings: "소중한 반려동물의 행복을 위한 든든한 동반자가 되겠습니다.",
    history: [
      "전북대학교 수의과대학 수의학사 졸업",
      "전) 동물메디컬센터W 진료수의사",
      "현) 부평SKY동물의료센터 응급의학과장",
    ],
    paper: [],
    education: [],
    completion: [],
  },
  {
    id: 22,
    position: "응급의학과장",
    name: "황동혁",
    title: "강원대학교 수의과대학 학사 졸업",
    img: vet22,
    timg: tvet22,
    greetings: "응급의 순간일수록 빠르게, 그러나 가볍지 않게 판단하겠습니다.",
    history: [
      "강원대학교 수의과대학 학사 졸업",
      "전) 이지동물의료센터 진료수의사",
      "전) 리브동물의료센터 진료원장",
      "전) 치료해주오 동물병원 대표원장",
      "현) 부평SKY동물의료센터 응급의학과장",
    ],
    paper: [],
    education: [],
    completion: [],
  },
//   {
//     id: 9,
//     position: "진료과장",
//     name: "정기욱",
//     title: "충북대학교 수의학사 졸업",
//     img: vet9,
//     timg: tvet9,
//     greetings: "보호자님의 마음까지 공감할 수 있는 수의사가 되겠습니다.",
//     history: [
//       "충북대학교 수의과대학 수의학사 졸업",
//       "충북대학교 수의과대학 수의외과학 석사 과정",
//       "현) 부평SKY동물의료센터 진료과장",
//     ],
//     paper: [
//       "2024 춘계 임상수의학회 포스터 발표. Autologous peritoneal graft for surgical reduction of cystic duct stump leakage in a dog.",
//     ],
//     education: [],
//     completion: [],
//   },
//   {
//     id: 10,
//     position: "진료수의사",
//     name: "유현철",
//     title: "충북대학교 수의학사 졸업",
//     img: vet10,
//     timg: tvet10,
//     greetings: "아이들을 사랑하는 수의사, 따뜻한 손길로 치료하겠습니다.",
//     history: [
//       "충북대학교 수의과대학 수의학사 졸업",
//       "전) 24시 마음든든동물병원 진료수의사",
//       "현) 부평SKY동물의료센터 진료수의사",
//     ],
//     paper: [],
//     education: [],
//     completion: [],
//   },
  {
    id: 11,
    position: "진료수의사",
    name: "노정은",
    title: "전북대학교 수의학사 졸업",
    img: vet11,
    timg: tvet11,
    greetings:
      "환자와 보호자님의 입장에서 생각하고 최선을 다해 진료하겠습니다.",
    history: [
      "전북대학교 수의과대학 수의학사 졸업",
      "현) 부평SKY동물의료센터 진료수의사",
    ],
    paper: [],
    education: [],
    completion: [],
  },
  {
    id: 12,
    position: "진료수의사",
    name: "최민정",
    title: "충북대학교 수의학사 졸업",
    img: vet12,
    timg: tvet12,
    greetings:
      "저와 만난 모든 아이들과 보호자님이 언제나 건강하고 행복하길 바라겠습니다.",
    history: [
      "충북대학교 수의과대학 수의학사 졸업",
      "현) 부평SKY동물의료센터 진료수의사",
    ],
    paper: [],
    education: [],
    completion: [],
  },
//   {
//     id: 13,
//     position: "진료수의사",
//     name: "최정민",
//     title: "충북대학교 수의학사 졸업",
//     img: vet13,
//     timg: tvet13,
//     greetings: "환자와 보호자님의 마음까지 치료하는 수의사가 되겠습니다.",
//     history: [
//       "충북대학교 수의과대학 수의학사 졸업",
//       "현) 부평SKY동물의료센터 진료수의사",
//     ],
//     paper: [],
//     education: [],
//     completion: [],
//   },
//   {
//     id: 17,
//     position: "진료수의사",
//     name: "이호연",
//     title: "충남대학교 수의과대학 수의학사 졸업",
//     img: vet17,
//     timg: tvet17,
//     greetings: "아이들을 제 가족처럼 소중히 여기며 감동과 희망을 전하는 수의사가 되겠습니다.",
//     history: [
//         "충남대학교 수의과대학 수의학사 졸업",
//         "전) 24시샤인동물메디컬센터 수련의",
//         "현) 부평SKY동물의료센터 진료수의사",
//     ],
//     paper: [
//     ],
//     education: [],
//     completion: [],
//   },
  {
    id: 18,
    position: "진료수의사",
    name: "원주연",
    title: "충북대학교 수의과대학 수의학사 졸업",
    img: vet18,
    timg: tvet18,
    greetings: "언제나 믿고 의지할 수 있는 평생 주치의가 되겠습니다.",
    history: [
      "충북대학교 수의과대학 수의학사 졸업",
      "현) 부평SKY동물의료센터 진료수의사",
    ],
    paper: [],
    education: [],
    completion: [],
  },
  {
    id: 19,
    position: "진료수의사",
    name: "최혜은",
    title: "충북대학교 수의과대학 수의학사 졸업",
    img: vet19,
    timg: tvet19,
    greetings: "저와 만난 모든 아이들과 보호자님이 언제나 건강하고 행복하길 바라겠습니다.",
    history: [
      "충북대학교 수의과대학 수의학사 졸업",
      "현) 부평SKY동물의료센터 진료수의사",
    ],
    paper: [],
    education: [],
    completion: [],
  },
];

export default vetInfo;
